import * as React from "react"


const LineS1 = React.forwardRef((props, pathRef) => {
        return (
            <svg
                id={"line-s-1"}
                width={320}
                height={569}
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                viewBox={`0 0 320 569`}
                preserveAspectRatio={`none`}
            >


                <path
                    d="M1 0v349.5c0 38.108 30.892 69 69 69h23c37.003 0 67 29.997 67 67V529"
                    stroke="#DEDDE2"
                    ref={pathRef}

                    strokeWidth={2}
                    strokeDashoffset={props.normalizedPosition}
                    strokeDasharray={props.pathLength}
                />
                <path
                    d="M319 0v349.5c0 38.108-30.892 69-69 69h-23c-37.003 0-67 29.997-67 67V529"
                    stroke="transparent"
                    strokeWidth={2}
                />

            </svg>
        )
    }
)

export default LineS1;
